import { render } from "./협력 병의원 현황.vue?vue&type=template&id=0136ccce"
import script from "./협력 병의원 현황.vue?vue&type=script&lang=js"
export * from "./협력 병의원 현황.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__